export default "__VITE_ASSET__Bofl2yzN__"